import angular from 'angular';

import notificationModule from '../ui/notification/notification.module';
import leadPopupChatButtonModule from './chat/lead.popup.chat.button.module';
import { leadPopupRoutesConfig } from './lead.popup.routes';

import '../activity/Activity.directive';
import '../tasks/EntityTasks.directive';

export default angular
  .module('lead.popup', [
    'ngResource',
    leadPopupChatButtonModule.name,
    notificationModule.name,
    'popup',
  ])
  .config(leadPopupRoutesConfig);
